import { handleJSON, stringifyParams } from '@/utils/fetch-utils';
import { headers, uploadFileHeaders } from './index';

const { LIVE_INSTRUCTION_API_URL } = process.env;

let abortController = new AbortController();

export default {
  endpoints: {
    teacherList: query => `${LIVE_INSTRUCTION_API_URL}/v0/admin/search/teacher/${query}`,
    createTeacherProfile: () => `${LIVE_INSTRUCTION_API_URL}/v1/teacher/settings`,
    teacherProfile: teacherHashEmail => `${LIVE_INSTRUCTION_API_URL}/v0/teacher/settings/${teacherHashEmail}`,
    teacherMediaProfile: (teacherHashEmail, mediaType) =>
      `${LIVE_INSTRUCTION_API_URL}/v0/teacher/settings/${teacherHashEmail}/${mediaType}`,
  },

  fetchTeachersList(params) {
    abortController.abort();
    abortController = new AbortController();

    const options = {
      method: 'GET',
      headers: headers(),
      signal: abortController.signal,
    };

    const query = stringifyParams(params);
    const endpoint = this.endpoints.teacherList(query);

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchTeacherProfile(teacherHashEmail) {
    abortController.abort();
    abortController = new AbortController();

    const options = {
      method: 'GET',
      headers: headers(),
      signal: abortController.signal,
    };

    const endpoint = this.endpoints.teacherProfile(teacherHashEmail);
    return fetch(endpoint, options).then(handleJSON);
  },

  createTeacherProfile(value) {
    abortController.abort();
    abortController = new AbortController();

    const options = {
      method: 'POST',
      headers: headers(),
      signal: abortController.signal,
      body: JSON.stringify(value),
    };

    const endpoint = this.endpoints.createTeacherProfile();
    return fetch(endpoint, options).then(handleJSON);
  },

  updateTeacherProfile({ teacherHashEmail, value }) {
    abortController.abort();
    abortController = new AbortController();

    const options = {
      method: 'PATCH',
      headers: headers(),
      signal: abortController.signal,
      body: JSON.stringify(value),
    };

    const endpoint = this.endpoints.teacherProfile(teacherHashEmail);
    return fetch(endpoint, options).then(handleJSON);
  },

  updateTeacherMediaProfile({ teacherHashEmail, value, mediaType }) {
    const file = new FormData();
    file.append('file', value.file);

    abortController.abort();
    abortController = new AbortController();

    const options = {
      method: 'PATCH',
      headers: uploadFileHeaders(),
      signal: abortController.signal,
      body: file,
    };

    const endpoint = this.endpoints.teacherMediaProfile(teacherHashEmail, mediaType);
    return fetch(endpoint, options).then(handleJSON);
  },
};
